import React from 'react'
import { createPortal } from 'react-dom'
import SuggestionsDropdown from '../SuggestionsDropdown'
import usePortalPosition from './usePortalPosition'
import useVisibilityDetection from './useVisibilityDetection'
import styles from './index.module.scss'

const SuggestionsDropdownPortal = ({
  showSuggestions,
  suggestedTemplates,
  maxVisibleSuggestions,
  onTemplateSelect,
  onViewAllTemplates,
  containerRef,
  setShowSuggestions,
  isUnifiedConversation,
}) => {
  const { position, dropdownContainerRef } = usePortalPosition({
    showSuggestions,
    containerRef,
  })

  useVisibilityDetection({
    showSuggestions,
    setShowSuggestions,
    containerRef,
  })

  if (!showSuggestions || suggestedTemplates.length === 0) {
    return null
  }

  const handleClose = () => {
    setShowSuggestions(false)
  }

  return createPortal(
    <div
      ref={dropdownContainerRef}
      className={styles.suggestionsOverlay}
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        width: `${position.width}px`,
        zIndex: 1000,
        bottom: 'auto', // Override CSS bottom property
        right: 'auto', // Override CSS right property
        marginBottom: '8px', // Add margin for spacing
      }}
    >
      <SuggestionsDropdown
        suggestedTemplates={suggestedTemplates}
        maxVisibleSuggestions={maxVisibleSuggestions}
        onTemplateSelect={onTemplateSelect}
        onViewAllTemplates={onViewAllTemplates}
        onClose={handleClose}
        isUnifiedConversation={isUnifiedConversation}
      />
    </div>,
    document.body
  )
}

export default SuggestionsDropdownPortal
